import { BiBriefcase, BiBuildings, BiMap, BiMoney } from "react-icons/bi";

const Filters = () => {
  return (
    <div className="sm:max-w-[80%] w-[95%] mx-auto relative -mt-10 sm:-mt-32">
      <div className="bg-secondary dark:bg-black/30  sm:!bg-black/30 backdrop-blur-sm p-4 border border-slate-600 rounded-lg text-slate-100">
        <div className="flex-col mt-4 gap-x-4 flex-center-between gap-y-4 md:gap-y-0 md:flex-row ">
          <div className="flex-col flex-1 w-full flex-align-center gap-x-4 md:w-fit sm:flex-row gap-y-4 sm:gap-y-0">
            <div className="flex-1 w-full p-2 rounded-lg md:w-fit  md:!bg-transparent">
              <h1 className="font-bold">Location</h1>
              <div className="flex-align-center gap-x-2">
                <BiMap />
                <h1 type="text"
                  className="w-full bg-transparent border-0 outline-none">
                  Shanzu, Mombasa.
                </ h1>
              </div>
            </div>
            <div className="h-10 w-[1px] hidden md:block "></div>
            <div className="flex-1 w-full p-2 rounded-lg md:w-fit  md:!bg-transparent">
              <h1 className="font-bold">Property Type</h1>
              <div className="flex-align-center gap-x-2">
                <BiBuildings />
                < h1 className="w-full bg-transparent border-0 outline-none text-slate-500">
                  1, 2 & 3 Bedroomed.
                </ h1>
              </div>
            </div>
          </div>
          <div className="h-10 w-[1px] bg-slate-300 hidden md:block"></div>
          <div className="flex-col flex-1 w-full flex-align-center gap-x-4 md:w-fit sm:flex-row gap-y-4 sm:gap-y-0">
            <div className="flex-1 w-full p-2 rounded-lg md:w-fit  md:!bg-transparent">
              <h1 className="font-bold">Price range</h1>
              <div className="flex-align-center gap-x-2">
                <BiMoney />
                <h1 className="w-full bg-transparent border-0 outline-none text-slate-500">
                Reach out
                </h1>
              </div>
            </div>
            <div className="h-10 w-[1px] bg-slate-300 hidden md:block"></div>
            <div className="flex-1 w-full p-2 rounded-lg md:w-fit  md:!bg-transparent">
              <h1 className="font-bold">For</h1>
              <div className="flex-align-center gap-x-2">
                <BiBriefcase />
                < h1 className="w-full bg-transparent border-0 outline-none text-slate-500">
                  Rent
                </ h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filters;
